import { NormalizedResponse } from '@tmx/data-access';

const isNormalizedResponse = (
  response: Response
): response is NormalizedResponse => {
  return 'error' in response && 'errorCode' in response;
};

/**
 * Use this to retrive the error context of an error. Meant to be used with reportToTrackjs()
 * @param error unknown Error, usually a Response or NormalizedResponse
 * @returns the error context from a Response or NormalizedResponse or the error as a Record<string, unknown> or unknown[]
 */
export const getErrorContext = (error: unknown) => {
  if (error instanceof Response) {
    if (isNormalizedResponse(error)) {
      return error.error;
    }

    const { status, statusText, url } = error;
    return { status, statusText, url };
  }

  if (typeof error === 'object') {
    if (Array.isArray(error)) {
      return error as unknown[];
    }

    return (error ?? {}) as Record<string, unknown>;
  }

  if (typeof error === 'string') {
    return error;
  }

  return 'Unknown Error';
};
